@if (needsAction()) {
  <div class="alert warning-emphasis">
    <div class="row align-items-center">
      <div class="col-auto">
        <div class="row align-items-center">
          <div class="col-auto pe-1">
            <i class="iconoir-warning-triangle"></i>
          </div>
          <div class="col">
            @if (idStatus(status()).isNull) {
              <strong>Action Required:</strong> Complete your profile verification to access your card.
            }
            @if (idStatus(status()).isRejected) {
              Your identification documents has been rejected.
              <br />
              Please contact our support team for further assistance.
            }
            @if (idStatus(status()).isError) {
              It's taking longer than expected to verify your identification documents.
              <br />
              Please contact our support team for further assistance.
            }
          </div>
        </div>
      </div>
      <div class="col-auto ms-auto">
        @if (idStatus(status()).isNull) {
          <a
            id="verifyIdentityBtn"
            routerLink="/verify-identity"
            class="ms-auto btn btn-sm btn-light">
            Verify
          </a>
        } @else {
          <a
            id="contactSupportBtn"
            [href]="helpCenterUrl"
            target="_blank"
            rel="noopener"
            class="ms-auto btn btn-sm btn-light">
            Contact Support
          </a>
        }
      </div>
    </div>
  </div>
}
